import type { Messages } from "../types";

export const ko = {
  "common": {
    "leave": "떠나다",
    "continue": "계속하다",
    "no": "아니요",
    "goBack": "돌아가기",
    "yes": "예",
    "pleaseWait": "기다리세요…",
    "saving": "절약…",
    "male": "남성",
    "ellipsis": "…",
    "female": "여성",
    "phases": {
      "gate": "문",
      "verify": "확인하다",
      "setup": "설정",
      "profile": "윤곽"
    },
    "brandTag": "독점 기독교 데이트",
    "leaveForNow": "지금은 떠나세요",
    "submitting": "제출 중…",
    "brand": "UN8",
    "charMetaMin": "최소 {min}자",
    "storageDisabled": "이 브라우저는 귀하의 답변을 저장하지 않습니다. 비공개 모드를 끄거나 사이트 데이터를 허용한 다음 다시 로드하세요.",
    "storageQuota": "이 휴대전화에 답변을 저장할 공간이 없습니다. 저장용량을 확보한 후 다시 시도해 보세요.",
    "charMeta": "{len}/{min}분 · {current}/{max}"
  },
  "welcome": {
    "promise": "우리의 목표는 귀하가 이 앱을 최대한 빨리 삭제하는 것입니다.",
    "signedInAs": "{email}(으)로 로그인됨",
    "liveServer": "· 라이브 서버",
    "deviceOnly": "· 이 기기에만 해당",
    "sub": "UN8는 진지한 기독교 싱글이 인생의 동반자를 찾고 떠나도록 도와줍니다. 확인되었습니다. 가치 우선. 끝없는 스와이프가 없습니다.",
    "uploadLocalProfile": "내 로컬 프로필 업로드",
    "begin": "시작하다",
    "migrateNeedGender": "먼저 프로필에서 남성 또는 여성을 선택하세요.",
    "migrateOffer": "이 장치에는 여전히 로컬 프로필이 있습니다. 검토 후 다른 전화기에서 귀하를 볼 수 있도록 공유 서버에 업로드하시겠습니까? 선택하기 전까지는 아무것도 업로드되지 않습니다.",
    "keepOnDevice": "이 기기에만 보관하세요",
    "logIn": "로그인",
    "matching": "매칭",
    "deleteMyAccount": "내 계정 삭제",
    "logOut": "로그아웃",
    "continueOnboarding": "계속해서 온보딩",
    "accountDeleted": "계정이 삭제되었습니다.",
    "deleteConfirm": "서버에서 계정, 모든 메시지, 모든 미디어(ID 및 동영상 포함)를 영구적으로 삭제하시겠습니까?",
    "reviewConsole": "콘솔 검토",
    "migrateDone": "프로필 텍스트가 업로드되었습니다. 중재자가 검토할 수 있도록 신분증, 동영상, 사진을 다시 업로드하세요."
  },
  "faith": {
    "eyebrow": "신앙의 문",
    "title": "기독교인들만",
    "respectTitle": "존경하는 마음으로",
    "noTitle": "나는 기독교인이 아니다",
    "yesTitle": "나는 기독교인이다",
    "yesBody": "나는 예수 그리스도를 따르며 이 믿음을 공유하는 결혼 지향적인 파트너를 찾습니다.",
    "noBody": "UN8은(는) 나에게 적합한 장소가 아닙니다. 그래도 괜찮습니다.",
    "respectBody": "UN8은 하나의 커뮤니티를 위해 만들어졌으며 시간을 낭비하기보다는 정직하게 행동하겠습니다. 귀하의 집이 아닌 경우 아래에 남겨 두거나 뒤로를 사용하세요.",
    "text": "UN8은(는) 예수 그리스도를 따르는 사람들의 커뮤니티로, 믿음을 공유하고 결혼을 염두에 두고 있는 파트너를 찾는 회원들을 위한 것입니다. 이 문은 건너뛸 수 없습니다.",
    "sharedBody": "여기서 믿음은 라벨이 아닙니다. 만나는 땅입니다.",
    "sharedTitle": "공유재단",
    "hintUnset": "계속하려면 “나는 기독교인입니다”를 누르고, 집이 아닌 경우 떠나거나 돌아가십시오.",
    "hintNotChristian": "UN8은(는) 예수 그리스도를 따르는 사람들을 위한 것입니다. 아래에서 탈퇴를 누르거나, 본인이라면 기독교인 옵션을 선택하세요."
  },
  "rules": {
    "respectful": {
      "title": "존중하라",
      "description": "품위 있게 말하고 행동하십시오. 여기 있는 모든 사람은 하나님의 형상대로 만들어졌습니다."
    },
    "title": "우리가 서로를 대하는 방법",
    "eyebrow": "공동체 서약",
    "text": "모든 규칙을 확인하세요. 세 가지가 모두 필요합니다. 위반하면 영구적으로 제거됩니다. 가짜 프로필은 영원히 금지됩니다.",
    "agreeContinue": "동의합니다 - 계속하세요",
    "noSexualContent": {
      "description": "노골적인 사진, 메시지 또는 요청이 없습니다. 여기서 순수성은 선택 사항이 아닙니다.",
      "title": "성적인 내용 없음"
    },
    "noDominance": {
      "title": "지배하거나 통제하지 마십시오",
      "description": "강요, 조작, 압력이 없습니다. 사랑은 통제하지 않습니다."
    },
    "hint": "계속하기 전에 세 가지 약속을 모두 선택하세요."
  },
  "intent": {
    "eyebrow": "",
    "title": "무엇을 찾고 있나요?",
    "text": "",
    "marriage": {
      "label": "평생의 동반자",
      "description": ""
    },
    "discernment": {
      "label": "진지한 분별",
      "description": ""
    },
    "notCasual": {
      "label": "가벼운 만남 아님",
      "description": ""
    },
    "hint": "하나를 고르세요."
  },
  "account": {
    "eyebrow": "계정",
    "handle": "핸들",
    "handlePlaceholder": "you@example.com 또는 짧은 이름",
    "savedContinue": "저장했습니다 — 계속하세요",
    "text": "핸들은 안정적인 사용자 ID를 생성합니다. 신청, 인증, 좋아요, 매칭이 모두 해당 ID에 바인딩됩니다. 이메일이 전송되지 않습니다.",
    "recoveryTitle": "복구 코드 저장",
    "title": "액세스 권한 만들기",
    "recoveryText": "한 번 표시됩니다. 그렇지 않으면 이 비공개 테스트에서 분실된 암호를 재설정할 수 없습니다.",
    "passphrase": "암호",
    "hintEmail": "@가 포함된 이메일 주소를 입력하세요.",
    "hintPassword": "비밀번호는 8자 이상으로 선택하세요.",
    "signedInBody": "{email} · {userId}",
    "signedInTitle": "로그인됨",
    "trustTitle": "신뢰 표준",
    "passphrasePlaceholder": "8자 이상",
    "continueToVerification": "계속해서 확인하세요",
    "trustBody": "신원 확인이 완료되고 중재자가 귀하를 승인할 때까지 프로필이 표시되지 않습니다."
  },
  "verify": {
    "intro": {
      "eyebrow": "확인",
      "text": "정부 발급 신분증, 확인 동영상, {min}~{max} 실제 사진을 업로드하세요. 프로필이 표시되기 전에 모든 것이 검토 대기열에 들어갑니다.",
      "whyBody": "메기낚시와 절반의 진실은 여기에 설 자리가 없습니다. 가짜 프로필은 영구적으로 금지됩니다. 미디어는 승인될 때까지 pending_review 상태로 저장됩니다.",
      "whyTitle": "우리가 확인하는 이유",
      "start": "인증 시작",
      "title": "신뢰가 문이다"
    },
    "steps": {
      "id": {
        "description": "여권 또는 국가 신분증 - 카메라 또는 파일 업로드.",
        "title": "정부 신분증"
      },
      "video": {
        "description": "귀하가 참석했음을 증명하는 짧은 녹음입니다.",
        "title": "확인 영상"
      },
      "photos": {
        "title": "실제 사진",
        "description": "본인의 선명한 사진 7~10장."
      },
      "review": {
        "title": "무결성 검토",
        "description": "업로드는 직원이 확인할 때까지 pending_review 상태로 유지됩니다."
      }
    },
    "id": {
      "title": "정부 신분증",
      "savedTitle": "아이디 저장됨",
      "eyebrow": "4단계 중 1단계",
      "savedBody": "그 다음에는 얼굴이 나온 짧은 확인 영상이 나오고, 그 다음에는 본인의 실제 사진 7~10장이 나옵니다. 이 ID에 저장된 것으로 표시되면 계속 잠금이 해제됩니다.",
      "text": "여권이나 주민등록증을 캡처하거나 업로드하세요. 공개적으로 게시된 내용은 없습니다. 직원이 확인할 때까지 상태는 pending_review로 유지됩니다.",
      "hint": "정부 발급 신분증 사진을 찍거나 업로드한 후 저장되었다고 표시될 때까지 기다립니다."
    },
    "video": {
      "title": "확인 영상",
      "eyebrow": "4단계 중 2단계",
      "hint": "짧은 확인 비디오를 녹화한 다음 저장되었다고 표시될 때까지 기다립니다.",
      "text": "짧은 클립을 녹화하거나 업로드하세요. 카메라를 바라보세요. 명확하게 말하세요. 이는 당신이 존재한다는 것을 증명합니다. 스크랩된 갤러리가 아닙니다."
    },
    "photos": {
      "title": "실제 사진",
      "continueToReview": "계속 검토하기",
      "eyebrow": "4단계 중 3단계",
      "hint": "자신의 선명한 사진 10장에 {min}을(를) 추가하세요. 저장되면 계속 잠금 해제됩니다.",
      "text": "본인의 최근 사진 {min}–10장을 추가하세요. 카메라나 라이브러리를 사용하세요. 사진을 제거하려면 ×를 탭하세요."
    },
    "review": {
      "eyebrow": "4단계 중 4단계",
      "title": "무결성 검토",
      "governmentId": "정부 신분증",
      "confirmationVideo": "확인 영상",
      "missing": "없어진",
      "text": "미디어가 pending_review{underUser}로 대기열에 추가되었습니다. 일치와 좋아요는 동일한 ID를 사용합니다.",
      "submittedTitle": "검토를 위해 제출됨",
      "filesReady": "{count} 파일 준비됨",
      "underUser": "사용자 {userId} 아래",
      "photos": "사진",
      "submittedText": "애플리케이션 ID는 인증 사용자 ID와 동일하므로 승인 → 풀 및 상호 좋아요가 정렬됩니다.",
      "submitContinue": "제출 및 계속"
    }
  },
  "setup": {
    "title": "자신에 대해 진실을 말하세요",
    "pillars": {
      "faith": {
        "name": "믿음",
        "text": "당신이 그리스도를 따르는 이유."
      },
      "character": {
        "name": "성격",
        "text": "충성도, 정직, 열정, 헌신 - 1~10점으로 평가됩니다."
      },
      "story": {
        "name": "이야기",
        "text": "당신은 누구이며 무엇을 찾고 있습니까?"
      },
      "life": {
        "name": "삶",
        "text": "취미, 독서, 직업."
      }
    },
    "text": "이러한 답변은 일치를 형성하고 검토에 나타납니다. 부드러운 거짓말은 당신을 포함해 모든 사람의 시간을 낭비합니다.",
    "beginSetup": "설정 시작",
    "eyebrow": "계정 설정",
    "whyChristian": {
      "eyebrow": "믿음",
      "title": "당신은 왜 기독교인입니까?",
      "label": "귀하의 답변",
      "text": "짧고 솔직한 답변입니다. 설교가 아니라 이유가 바로 당신의 것입니다.",
      "placeholder": "예를 들어 나는 상실의 시기에 그리스도를 만났고 그 이후로 그분을 따랐습니다…",
      "hint": "당신이 예수님을 따르는 이유를 최소 {min}자 이상 적어보세요."
    }
  },
  "scales": {
    "eyebrow": "문자 스케일",
    "title": "자신을 솔직하게 평가해 보세요",
    "passion": {
      "hint": "확신과 깊이 - 성과가 아닙니다.",
      "label": "당신은 얼마나 열정적입니까?"
    },
    "honesty": {
      "hint": "당신은 얼마나 일관되게 진실을 말합니까?",
      "label": "정직함의 정도"
    },
    "loyalty": {
      "hint": "솔직해지세요. 당신은 사랑하는 사람들 곁에 얼마나 충실하게 서 있습니까?",
      "label": "충성도 수준"
    },
    "text": "충성심, 정직, 열정, 헌신 - 각각 1부터 10까지입니다. 숫자를 부풀리면 나중에 일치하지 않을 뿐입니다. 계속하려면 모든 규모를 설정해야 합니다.",
    "commitment": {
      "label": "헌신의 수준",
      "hint": "오래 지속되는 무언가를 만들 준비가 얼마나 되셨나요?"
    },
    "hint": "숫자가 표시되도록 모든 슬라이더를 이동하십시오. 대시로 남아 있는 슬라이더는 없습니다."
  },
  "about": {
    "eyebrow": "당신에 대해",
    "label": "당신에 대해",
    "title": "자신을 몇 문장으로 설명해보세요",
    "text": "아무도 공연하지 않을 때 당신은 누구입니까? 기질, 리듬, 매일매일 중요한 것이 무엇인지.",
    "hint": "자신에 대해 최소 {min}자를 작성하세요.",
    "placeholder": "조용한 아침, 가족에 대한 진지함, 쉽게 웃으며 소음보다 깊이를 선호합니다…"
  },
  "looking": {
    "eyebrow": "파트너",
    "title": "무엇을 찾고 계신가요?",
    "hint": "원하는 파트너에 대해 최소 {min}자 이상 작성하세요.",
    "text": "외모에 대한 쇼핑 목록이 아니라 잠재적인 파트너에게서 원하는 주인공 특성입니다.",
    "placeholder": "예를 들어 확고한 믿음, 정서적 성숙, 스트레스 속에서도 친절함...",
    "label": "원하는 캐릭터 특성"
  },
  "loveReady": {
    "eyebrow": "한계점",
    "title": "평생의 사랑을 만날 준비가 되셨나요?",
    "text": "UN8는 진지한 싱글들이 파트너를 찾을 수 있도록 존재합니다. 그런 다음 앱을 삭제하세요. \"예\"만 잠금 해제가 계속됩니다.",
    "noTitle": "아직 아님",
    "comeBackTitle": "준비되면 다시 오세요",
    "yesTitle": "네 — 준비됐어요",
    "hintUnset": "누군가를 만나 결혼할 준비가 되었다면 예를 누르세요.",
    "noBody": "탐색만 하시는 경우에는 이 커뮤니티가 적합하지 않습니다.",
    "comeBackBody": "UN8는 옵션을 수집하는 것이 아니라 만날 준비가 된 사람들을 위한 것입니다. 지금 중단하려면 아래에 남겨두기를 사용하세요. 귀하의 답변은 이 휴대전화에 저장됩니다.",
    "hintNo": "\"예\"만 계속됩니다. 아직 준비되지 않았다면 지금은 나가기를 탭하세요. 답변은 이 휴대전화에 남아 있습니다.",
    "yesBody": "나는 명확하고 용기있게 내 사람을 만나기 위해 여기에 있습니다."
  },
  "lifestyle": {
    "eyebrow": "라이프스타일",
    "hobbies": "현재 스포츠나 취미",
    "title": "하루하루 살아가는 방법",
    "reading": "읽어요?",
    "profession": "직업 / 분야",
    "text": "스포츠, 취미, 독서, 직업 — 실제 호환성을 나타내는 실용적인 신호입니다.",
    "hobbiesPlaceholder": "당신이 적극적으로 하는 일 - 한때 하던 일이 아닙니다.",
    "hintProfession": "짧은 단어라도 자신이 하는 일을 입력하세요.",
    "readingHint": "1 = 거의 안 함 · 10 = 매일, 깊이 읽기",
    "professionPlaceholder": "예를 들어 간호 · 소프트웨어 · 교육 · 무역",
    "hintReading": "슬라이드 “읽으세요?” 1부터 10까지의 숫자가 표시됩니다.",
    "hintHobbies": "실제로 하고 있는 스포츠나 취미를 하나 이상 말해보세요."
  },
  "faithDepth": {
    "eyebrow": "매칭·신앙",
    "servingHint": "10% ~ 100%. 10단계로 슬라이드하세요.",
    "frequent": {
      "label": "잦은",
      "hint": "그리스도의 몸과 함께 정기적으로 모이는 것입니다."
    },
    "seldom": {
      "label": "드물게",
      "hint": "가끔 주간 리듬이 아닌 경우도 있습니다."
    },
    "keepsCommandments": "계명을 지키십니까?",
    "serving": "하나님을 섬기는 것 - 중요성",
    "title": "당신의 믿음은 얼마나 중심에 있습니까?",
    "text": "하나님을 섬기는 것, 당신의 삶에서 얼마나 중요한가요? 솔직하게 대답하세요. 매칭은 성능이 아닌 깊이를 위해 이것을 사용합니다.",
    "grewUpInChurch": "교회에서 자랐나요?",
    "never": {
      "label": "절대",
      "hint": "현재 참석하지 않습니다."
    },
    "churchAttendance": "교회 출석",
    "hasIdols": "아이돌이 있나요?",
    "hintCommandments": "당신이 계명을 지키는지 대답하십시오 - 예 또는 아니오.",
    "hintGrewUp": "당신이 교회에서 자랐는지 대답해 보세요 - 예 또는 아니오.",
    "hintAttendance": "교회에 얼마나 자주 참석하는지 선택하세요.",
    "spreadsGospel": "복음을 전하시나요?",
    "hintIdols": "당신에게 우상이 있는지 대답해 보세요 - 예, 아니오.",
    "hintServing": "당신의 삶에서 하나님을 섬기는 것이 얼마나 중요한지 슬라이드해 보세요.",
    "hintGospel": "당신이 복음을 전하는지 대답해 보세요 - 예, 아니오."
  },
  "character": {
    "caring": "배려와 애정이 있나요?",
    "eyebrow": "매칭 · 캐릭터",
    "peacemaker": "당신은 평화를 이루는 사람입니까?",
    "homebuilder": "당신은 주택 건설업자입니까?",
    "humorous": "당신은 유머러스합니까?",
    "title": "당신은 집에 누구입니까",
    "text": "구애의 성격 — 평화를 이루는 것, 매너, 정직. 답을 부풀리면 나중에 일치하지 않을 뿐입니다.",
    "manners": "매너가 좋은가요?",
    "peacefulHome": "싸움이 없는 평화로운 집을 원하십니까?",
    "hintHumorous": "당신이 유머러스한지 대답해 보세요.",
    "honestyRating": "이 설문지에 대한 정직성 등급",
    "hintHomebuilder": "당신이 주택 건설업자인지 답변해 보세요.",
    "honestyHint": "1~10 - 얼마나 솔직하게 대답하고 있나요?",
    "hintCaring": "당신이 배려하고 애정이 있는지 대답하십시오.",
    "hintPeacemaker": "중재자부터 시작하여 각각 예 또는 아니요로 답하십시오.",
    "hintManners": "매너가 좋은지 답해 보세요.",
    "hintPeaceful": "평화로운 집을 원하는지 대답해 보세요.",
    "hintHonesty": "정직성 등급을 1에서 10으로 슬라이드하세요."
  },
  "history": {
    "lsd": "LSD를 사용해 보셨나요?",
    "eyebrow": "매칭 · 내역",
    "marijuana": "마리화나를 사용해 보셨나요?",
    "title": "과거와 준비",
    "text": "물질, 어린 시절, 상처, 그리고 지속적인 관계를 맺을 준비가 되었는지 여부. 여기의 진실은 두 사람 모두를 보호합니다.",
    "childhood": "안정적이고 사랑스러운 어린 시절?",
    "hintLsd": "LSD 질문에 대답하십시오 - 예 또는 아니오.",
    "hintOtherDrugs": "다른 약물을 사용한 적이 있는지 답변해 주십시오.",
    "otherDrugs": "다른 약을 사용해 본 적이 있나요?",
    "lasting": "지속적인 관계를 맺을 준비가 되셨나요?",
    "scars": "흉터/손상은 없나요?",
    "addicted": "중독됐나요?",
    "hintLasting": "지속적인 관계를 맺을 준비가 되었는지 답변해 보세요.",
    "hintChildhood": "당신의 어린 시절이 안정되고 사랑스러웠는지 대답해 보세요.",
    "hintStart": "이 페이지의 맨 위부터 시작하여 모든 예 또는 아니요에 답하십시오.",
    "hintScars": "흉터가 있는지 대답해 보세요.",
    "hintAddicted": "중독되었는지 답변해 보세요."
  },
  "appearance": {
    "eyebrow": "매칭·외모",
    "hintAccepts": "파트너의 문신이 당신에게 허용되는지 말해보세요.",
    "text": "귀하의 문신 및 파트너의 문신이 귀하에게 허용되는지 여부.",
    "title": "문신",
    "hasTattoos": "문신이 있나요?",
    "hintHas": "문신이 있는지 여부를 말해보세요 - 예 또는 아니오.",
    "acceptsPartner": "파트너의 문신을 수락하시겠습니까?"
  },
  "home": {
    "herbKnowledge": "허브 지식?",
    "eyebrow": "매칭 · 집과 땅",
    "title": "토지, 기술, 자급자족",
    "text": "허브, 식품 재배, 과일 숲, 준비, 공동체 농업, 보존, 생존 및 기타 특별한 기술.",
    "canning": "통조림으로 만들고 보존하나요?",
    "prepping": "재난에 대비하고 있나요?",
    "survival": "생존 기술?",
    "specialSkills": "특수 기술(선택 사항)",
    "plantOwn": "과일과 채소를 직접 심나요?",
    "communityFarming": "공동체 농업/자립생활?",
    "fruitForest": "과일 숲에 관심이 있으세요?",
    "specialPlaceholder": "그 밖에 당신이 가구나 땅에 가져온 것…",
    "hintPlant": "과일과 채소를 직접 재배하는지 여부를 답해 주십시오.",
    "hintStart": "맨 위에서부터 토지와 스킬에 대해 각각 예 또는 아니요로 대답하세요.",
    "hintCommunity": "공동체 농업에 관심이 있는지 답변해 보세요.",
    "hintSurvival": "생존능력이 있는지 답변해 보세요.",
    "hintFruitForest": "과일 숲에 관심이 있는지 답해 보세요.",
    "hintPrepping": "재난에 대비하고 있는지 답변해 보세요.",
    "hintCanning": "음식을 보존하고 보존할 수 있는지 여부를 답해 주십시오."
  },
  "family": {
    "title": "어린이, 신앙의 깊이, 물질",
    "open": {
      "label": "열려 있는",
      "hint": "분별력 — 어느 쪽이든 잠겨 있지 않습니다."
    },
    "children": "어린이들",
    "doesNotWant": {
      "label": "아이를 원하지 않는다",
      "hint": "어린이에 대해서는 아니오를 선택하십시오."
    },
    "eyebrow": "매칭 · 가족",
    "wants": {
      "label": "자녀를 원함",
      "hint": "가족을 이루는 것은 비전의 일부입니다."
    },
    "hasLivingWith": {
      "label": "자녀가 있음 - 그들과 함께 살고 있음",
      "hint": "아이들은 이미 일상생활의 일부입니다."
    },
    "text": "신앙 강도, 자녀, 과거 약물 사용에 대한 파트너에게 필요한 것.",
    "hintFaith": "파트너에게 바라는 최소한의 믿음 수준을 슬라이드하세요.",
    "hintSubstances": "파트너의 과거 약물 사용이 허용되는지 여부를 말하십시오.",
    "requiredFaith": "파트너에게 필요한 최소 믿음 수준",
    "acceptsSubstances": "파트너의 과거 약물 사용을 인정하시겠습니까?",
    "hintChildren": "어린이에 관한 카드 한 장을 선택하세요.",
    "requiredFaithHint": "10% ~ 100%. 양측이 모두 응답한 경우 하드 게이트입니다."
  },
  "ancestry": {
    "eyebrow": "매칭 · 배경",
    "title": "배경 환경설정",
    "openToPartner": "파트너에게 공개",
    "codeDesc": "코드: {code}",
    "anyDesc": "폭을 가장 선호합니다. 확실하지 않은 경우 권장됩니다.",
    "text": "당신의 배경과 당신이 파트너로서 어떤 일을 하고 있는지 공유하세요. 이는 순위를 형성할 뿐이며 덱에서 누군가를 숨기지 않습니다.",
    "preferenceOnly": "선호 사항만 — 게이트가 아닙니다.",
    "hintOwn": "당신을 설명하는 배경을 하나 이상 선택하십시오. 이는 순위에만 도움이 되며 누구도 숨기지 않습니다.",
    "yourBackground": "귀하의 배경(해당 사항 모두 선택)",
    "hintAccepted": "파트너 중에서 귀하가 원하는 것이 무엇인지 선택하거나 \"개방 - 선호 사항 없음\"을 선택하십시오."
  },
  "interests": {
    "hint": "관심 분야를 하나 이상 선택하세요.",
    "title": "당신이 즐기는 것",
    "text": "하나 이상을 선택하세요. 겹치는 것은 순위를 매기는 데 도움이 됩니다. 침묵은 결코 처벌되지 않습니다.",
    "eyebrow": "매칭·관심사"
  },
  "reflection": {
    "describeYourself": "자기소개",
    "text": "이 네 가지 답변은 전체 내용으로 표시되며 점수가 매겨지지 않습니다. 무엇이 진실인지 쓰십시오.",
    "eyebrow": "매칭·반성",
    "lifePurpose": "삶의 목적",
    "title": "당신의 말로",
    "weaknesses": "약점",
    "hintVision": "15년 비전을 {min}자 이상으로 작성하세요.",
    "hintWeaknesses": "최소 {min} 문자로 약점을 지정하세요.",
    "hintPurpose": "당신의 인생 목적을 {min}자 이상으로 적어보세요.",
    "hintDescribe": "최소 {min}자로 자신을 설명하세요.",
    "fifteenYear": "15년 후 당신과 당신의 인생에 대한 사랑"
  },
  "profile": {
    "eyebrow": "윤곽",
    "firstName": "이름",
    "title": "몇 가지 필수 사항",
    "text": "간단하게 유지하세요. 여기서 성별은 명확한 일치를 위해 남성 또는 여성이라는 이분법으로 구분됩니다.",
    "firstNamePlaceholder": "당신이 알려지고 싶은 대로",
    "age": "나이",
    "city": "도시",
    "sex": "섹스",
    "agePlaceholder": "18세 이상",
    "femaleBody": "나는 여자입니다.",
    "cityPlaceholder": "당신이 거주하는 곳",
    "hintAge": "연령은 18세 이상이어야 합니다.",
    "maleBody": "나는 남자입니다.",
    "hintCity": "당신이 살고 있는 도시를 입력하세요.",
    "hintName": "이름을 입력하세요(최소 두 글자).",
    "hintGender": "매칭이 작동하도록 남성 또는 여성을 선택하세요."
  },
  "ready": {
    "title": "입장할 수도 있습니다.",
    "genderProfession": "{gender} · {profession}",
    "professionFallback": "직업",
    "christianRules": "기독교 · 규칙 확인",
    "textNamed": "{name}, 확인 및 설정이 기록되었습니다. 미디어가 pending_review 상태입니다. UN8에 오신 것을 환영합니다. 귀하의 사람을 찾은 다음 앱을 삭제하세요.",
    "scalesLine": "저울 L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "mediaLine": "신분증 · 동영상 · {photoCount} 사진 · 대기열 {pending}",
    "text": "확인 및 설정이 기록됩니다. 미디어가 pending_review 상태입니다. UN8에 오신 것을 환영합니다. 귀하의 사람을 찾은 다음 앱을 삭제하세요.",
    "sexUnset": "섹스 —",
    "summaryAria": "설정 요약",
    "userLine": "사용자 {userId}",
    "enterMatching": "매칭 입력",
    "needGender": "프로필 단계로 돌아가서 남성 또는 여성을 선택한 후 다시 시도하세요."
  },
  "match": {
    "navOnboarding": "온보딩",
    "brandTag": "매칭",
    "navReview": "검토",
    "logOut": "로그아웃",
    "navMatching": "매칭",
    "email": "이메일",
    "password": "비밀번호",
    "logIn": "로그인",
    "enterTitle": "매칭 입력",
    "guestMan": "남자로서의 손님",
    "passwordPlaceholder": "귀하의 비밀번호",
    "emailPlaceholder": "you@example.com",
    "woman": "여성",
    "man": "남성",
    "tabToday": "선정",
    "guestOr": "또는 게스트 세션을 사용해 보세요(브라우저당 안정적인 ID · 데모에만 해당)",
    "enterText": "온보딩과 동일한 이메일로 로그인하세요. 신청, 풀, 좋아요, 매칭 모두 안정적인 사용자 ID를 사용합니다.",
    "like": "좋다",
    "likes": "좋아한다",
    "guestSession": "게스트 세션 · 데모 풀",
    "tabMatches": "일치({count})",
    "valuesScore": "값 {score}",
    "emptyMatches": "아직 상호 관심은 없습니다. 이번 주 선정을 계속 분별하십시오.",
    "goOnboarding": "온보딩으로 이동 →",
    "yourMatches": "귀하의 경기",
    "guestWoman": "손님 여성으로",
    "matchesSub": "지속적인 상호 관심 · {count} 아웃바운드 {likesWord}",
    "cityValues": "{city} · 값 {score}",
    "matchingPaused": "매칭이 일시중지되었습니다.",
    "chatOpen": "· 채팅 오픈",
    "noProfileYet": "아직 프로필이 없습니다",
    "noOneYet": "아직 표시할 사람이 없습니다.",
    "personLine": "{name}, {age}",
    "tapToChat": "· 채팅하려면 탭하세요.",
    "demoPool": "데모",
    "noProfileText": "온보딩을 완료하거나 상단에서 온보딩을 탭한 다음 시작을 탭하세요. 게스트 매칭은 보기만 하고 싶다면 입장 화면에 있습니다.",
    "livePool": "{source}({count})",
    "likesMayNotStick": "좋아요가 붙지 않을 수 있습니다.",
    "todaysSetDone": "이번 주 선정입니다",
    "emptyNeverHad": "이번 주 선정 목록에는 아무도 없습니다. 방금 온보딩을 마친 경우 라이브 풀은 여전히 비어 있을 수 있습니다. 게스트 세션을 통해 데모 사용자를 확인하거나 더 많은 멤버가 승인된 후 다시 돌아오세요.",
    "backOnboarding": "온보딩으로 돌아가기",
    "resetDeck": "데크 재설정",
    "pass": "통과하다",
    "feedEyebrowDemo": "주간 선정 · 데모 풀",
    "interested": "관심 있는",
    "likeHeart": "♥ 좋아요",
    "heartsNoneLeft": "이번 주 하트가 모두 소진되었습니다. 월요일에 다시 돌아옵니다.",
    "commentLead": "{name}에게 한마디만. 열 단어.",
    "commentPlaceholder": "열 단어, 그 이상은 안 됩니다",
    "commentCount": "{count} / {max}",
    "commentSend": "이 메시지와 함께 하트 보내기",
    "heartOnly": "하트만",
    "commentTooLong": "{max}단어를 넘었습니다. 하트는 보냈지만 메모는 보내지 않았습니다.",
    "commentAnchors": {
      "about": "소개",
      "lookingFor": "찾는 것",
      "hobbies": "관심사",
      "photo": "사진"
    },
    "inboundTitle": "나를 좋아함",
    "likeBack": "좋아요로 답하기",
    "poolMeta": "풀: {pool} · 일치 항목: {matches} · 좋아요: {liked}",
    "emptyDone": "이번 주 선정을 살펴보았습니다. 다음 주에 다시 오거나 덱을 재설정하여 다시 살펴보세요.",
    "celebrationEyebrow": "상호 이익",
    "left": "{count} 남음",
    "feedTitle": "신중하게 판단하세요",
    "celebrationTitle": "당신은 일치했습니다",
    "swipeHint": "버튼을 스와이프하거나 사용하세요. 일치는 상호 관심이 지속되는 경우에만 시작됩니다.",
    "celebrationNote": "이 경기에서는 채팅이 잠금 해제됩니다. 존중을 유지하세요. 편리함보다 약속을 지키세요.",
    "feedEyebrowLive": "주간 선정 · 풀({source}, {count})",
    "celebrationText": "{self} 및 {other} 모두 관심을 보였습니다. 값 정렬: {score}.",
    "affinity": "유연",
    "openChat": "오픈채팅",
    "scoreStrong": "강력한 정렬",
    "keepDiscerning": "분별력을 유지하라",
    "cardSeeking": "추구",
    "scoreDifferent": "다른 리듬",
    "cardHobbies": "취미",
    "scoreModerate": "보통 정렬",
    "valuesScoreLabel": "가치 점수",
    "scoreSolid": "솔리드 정렬",
    "stampPass": "통과하다",
    "stampInterest": "관심",
    "youThem": "당신은 {self} · 그들 {other}",
    "characterAxisFoot": "캐릭터 축에는 4개의 기둥이 포함됩니다.",
    "explainLegacyClose": "귀하의 가치 점수는 서로 가깝게 위치합니다({score}/100).",
    "explainLegacyFuller": "두 사람 모두 짝짓기 질문을 마친 후에는 더 자세한 \"이유\"가 나타납니다.",
    "explainHome": "당신은 토지, 식량 재배 또는 자급자족하는 집에 관심을 공유합니다.",
    "explainPurpose": "당신도 자신의 정직함을 비슷하게 평가했는데, 이는 공유된 진지함의 표시입니다.",
    "explainFaith": "당신의 믿음의 강도는 비슷합니다. 당신도 비슷한 진지함으로 예수님을 따르게 됩니다.",
    "explainCharacter": "집에서 사람들을 대하는 방법은 평화, 매너, 배려입니다.",
    "explainAncestry": "둘 다 비슷한 가족 배경을 선호합니다. 이는 필터가 아니라 선호 사항입니다. 누구도 이를 숨길 수 없습니다.",
    "explainTemperament": "당신의 관심사와 기질이 겹칩니다.",
    "affinityAxes": {
      "temperament": "기질에 적합",
      "faith": "신앙 강도",
      "character": "성격 및 행동",
      "home": "가정 및 자급자족",
      "purpose": "삶의 목적 정렬",
      "ancestry": "문화 및 배경 친화력"
    },
    "scaleAxes": {
      "loyalty": "충의",
      "honesty": "정직",
      "commitment": "약속",
      "passion": "열정"
    },
    "explainOverall": "전체 선호도 {score}/100.",
    "explainFallback": "두 사람이 모두 입력한 답변과 일치하는 항목이 있을 수 있습니다.",
    "weeklyTitle": "이번 주 4명",
    "weeklyTitleCount": "이번 주 {count}명",
    "weeklyCountdown": "다음 선택까지 {days}일",
    "weeklyCountdownOne": "다음 선택까지 1일",
    "weeklyCountdownSoon": "다음 선택 곧",
    "shortWeekCopy": "이번 주에는 {count}명입니다. 맞지 않는 사람은 절대 제안하지 않습니다.",
    "shortWeekTwo": "이번 주에는 두 명입니다. 맞지 않는 사람은 절대 제안하지 않습니다.",
    "weekDone": "이번 주 선택이 끝났습니다",
    "weekDoneText": "정직하게 제안할 수 있는 모든 분을 살펴보셨습니다. 다음 선택이 열리면 다시 오세요.",
    "waitingModeration": "선택이 열리기 전에 프로필이 검토 승인을 기다리고 있습니다.",
    "completeProfileFirst": "먼저 프로필을 완료하고 제출하세요.",
    "moderationDemoNote": "매칭을 미리 체험할 수 있도록 데모 프로필을 보여 드립니다.",
    "navSelection": "선택",
    "navMessages": "메시지",
    "navProfile": "프로필",
    "packTitle": "당신의 네 명",
    "packSkip": "탭하여 계속",
    "newSelection": "새 선정",
    "backToFour": "← 네 명으로 돌아가기",
    "whoLikedTitle": "나를 좋아한 사람",
    "whoLikedEmpty": "아직 새로 좋아한 사람이 없습니다.",
    "whoLikedLocked": "주간 선정에서 이름을 보려면 구독하세요 — 받은 하트는 메시지에 그대로 표시됩니다."
  },
  "chat": {
    "brandTag": "채팅",
    "valuesSubscriber": "값 {score} · 구독자",
    "unavailableText": "이 일치 항목이 누락되었거나 귀하의 세션에 속하지 않습니다.",
    "ariaMessage": "메시지",
    "send": "보내다",
    "unavailableTitle": "채팅 불가",
    "backToMatches": "경기로 돌아가기",
    "placeholder": "메시지 {name}…",
    "backMatches": "← 경기",
    "valuesTrial": "값 {score} · 평가판",
    "valuesKept": "값 {score} · 일치 항목 유지",
    "empty": "조심스럽게 인사하세요. 공유 백엔드에서 메시지는 상호 일치 후 두 전화기 모두에 동기화됩니다."
  },
  "billing": {
    "renewal": "갱신",
    "subscriberUntil": "구독자 · {date}까지",
    "soon": "곧",
    "signInToMatch": "매칭을 사용하려면 로그인하세요.",
    "paywallCopy": "무료 평가판 이후에는 이미 매칭된 모든 사람을 유지하고 계속 채팅하세요. 새로운 사람들을 보려면 구독하세요.",
    "subscribeEarly": "조기 구독 · ${price}/월",
    "subscribe": "구독 · ${price}/월",
    "trialEnded": "평가판이 종료됨 · 경기 및 채팅은 계속 열려 있음",
    "signInFirst": "먼저 로그인하세요.",
    "freeTrial": "무료 평가판 · {days}일({date} 종료)",
    "activeNote": "구독이 활성화되었습니다. 새로운 사람들을 다시 볼 수 있습니다.",
    "playOnly": "구독은 Google Play Billing(앱 설치)만 가능합니다. 여기서는 웹 결제가 없습니다.",
    "playOnlyShort": "Google Play 결제만 — 웹 결제 없음."
  },
  "auth": {
    "recoveryTitle": "복구 코드 저장",
    "savedContinue": "저장했습니다 — 계속하세요",
    "tabRegister": "등록하다",
    "tabLogin": "로그인",
    "handle": "핸들",
    "passphrase": "암호",
    "handlePlaceholder": "you@example.com 또는 짧은 이름",
    "passphrasePlaceholder": "8자 이상",
    "submitLogin": "로그인",
    "welcomeBack": "돌아온 것을 환영합니다",
    "intro": "핸들 및 암호. 이메일이나 SMS가 전송되지 않습니다. 귀하의 ID는 온보딩, 검토, 매칭 전반에 걸쳐 안정적으로 유지됩니다.",
    "createAccount": "계정 만들기",
    "recoveryText": "지금 이것을 적어보세요. 한 번 표시됩니다. 암호를 잊어버린 경우 비공개 테스트에서 암호를 재설정할 수 있는 유일한 방법은 이 코드입니다.",
    "submitRegister": "계정 만들기",
    "backWelcome": "환영으로 돌아가기"
  },
  "options": {
    "origin": {
      "african": "아프리카 사람",
      "european": "유럽 ​​사람",
      "asian": "아시아 사람",
      "middleEastern": "중동",
      "mixed": "혼합",
      "german": "독일 사람",
      "dutch": "네덜란드 사람",
      "other": "다른",
      "indigenous": "원주민",
      "any": "개방형 - 선호 사항 없음",
      "latino": "라틴계/히스패닉"
    },
    "interest": {
      "prayer": "기도",
      "cooking": "요리",
      "reading": "독서",
      "music": "음악",
      "worship": "예배",
      "hiking": "하이킹",
      "crafts": "공예",
      "sports": "스포츠",
      "outdoors": "옥외",
      "farming": "농업 / 원예",
      "family": "가족 생활",
      "missions": "임무"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "예",
      "no": "아니요"
    },
    "id": {
      "titleEmpty": "정부 신분증",
      "titleReady": "신분증 준비됨",
      "retake": "다시 잡다",
      "chooseFile": "파일 선택",
      "remove": "제거하다",
      "hintEmpty": "여권 또는 국가 신분증. 라이브 사진을 찍거나 이미지/PDF를 선택하세요. 네 모퉁이가 모두 보입니다.",
      "takePhoto": "사진 찍기",
      "uploading": "업로드 중…",
      "pdfAria": "PDF 문서가 선택됨",
      "replaceFile": "파일 교체",
      "savedSuffix": "· 저장됨",
      "cameraTitle": "신분증 사진 촬영",
      "hintReady": "{fileName} · {bytes}{saved}",
      "previewAlt": "주민등록증 미리보기",
      "badFile": "이 파일을 사용할 수 없습니다.",
      "uploadFailed": "업로드에 실패했습니다. 다시 시도해 보세요.",
      "signIn": "ID를 업로드하기 전에 로그인하세요."
    },
    "video": {
      "titleEmpty": "확인 영상",
      "hintReady": "{fileName} · {bytes}{saved}",
      "record": "기록",
      "rec": "REC {seconds}s",
      "titleReady": "비디오 준비됨",
      "titleLive": "카메라 라이브",
      "cameraUpload": "카메라 업로드",
      "chooseFile": "파일 선택",
      "cancel": "취소",
      "replaceFile": "파일 교체",
      "hintEmpty": "귀하의 이름을 말하고 UN8에 가입했음을 솔직하게 말하세요. 5~15초.",
      "remove": "제거하다",
      "uploadFailed": "업로드에 실패했습니다. 다시 시도해 보세요.",
      "badVideo": "이 동영상을 사용할 수 없습니다.",
      "signIn": "비디오를 업로드하기 전에 로그인하세요.",
      "saveFailed": "녹음을 저장할 수 없습니다.",
      "unsupported": "여기서는 실시간 녹화가 불가능합니다. 카메라 업로드를 사용하거나 파일을 선택하세요.",
      "permissionDenied": "카메라 권한이 거부되었습니다. 짧은 동영상 파일은 계속 업로드할 수 있습니다.",
      "stopSave": "중지 및 저장",
      "recordAgain": "다시 녹음하세요",
      "startRecording": "녹음 시작"
    },
    "photos": {
      "count": "{count} / {max} 사진",
      "moreRequired": "{n}개 더 필요",
      "listAria": "인증사진",
      "minimumMet": "최소 충족",
      "photoAlt": "사진 {n}",
      "camera": "카메라",
      "uploading": "업로드 중…",
      "takePhoto": "사진 찍기",
      "addFailed": "사진을 추가할 수 없습니다.",
      "cameraTitle": "자신의 사진을 찍어보세요",
      "removeAria": "사진 삭제 {n}",
      "chooseFiles": "파일 선택",
      "signIn": "사진을 업로드하기 전에 로그인하세요.",
      "someFailed": "일부 사진을 업로드하지 못했습니다. 실패한 것을 다시 시도하십시오.",
      "hint": "사진 찍기가 라이브 카메라를 엽니다. 파일 선택은 갤러리 선택에만 해당됩니다. 선명한 얼굴 사진 - 신원을 숨기는 필터가 없습니다. 최대 {max}."
    },
    "liveStill": {
      "titleDefault": "카메라",
      "close": "닫다",
      "capture": "포착",
      "cancel": "취소",
      "hint": "가만히 있어라. 라이브 카메라는 캡처할 때까지 열려 있습니다.",
      "frameFailed": "이 프레임을 캡처할 수 없습니다.",
      "saveFailed": "사진을 저장할 수 없습니다.",
      "unavailable": "이 브라우저에서는 카메라를 사용할 수 없습니다. 대신 파일 선택을 사용하세요.",
      "permissionDenied": "카메라 권한이 거부되었거나 사용할 수 없습니다. 대신 파일 선택을 사용하세요."
    },
    "uploadStatus": {
      "uploaded": "업로드됨",
      "failed": "업로드 실패",
      "savedLocally": "로컬에 저장됨",
      "uploading": "업로드 중…",
      "localFallbackNote": "{error} 파일이 이 장치에 저장되었습니다. 서명 끝점이 작동되면 다시 시도하세요.",
      "stored": "저장됨",
      "awaitingUpload": "업로드 대기 중"
    }
  },
  "shell": {
    "back": "뒤쪽에",
    "goBackAria": "돌아가기"
  },
  "language": {
    "label": "언어",
    "choose": "언어를 선택하세요"
  },
  "questionnaire": {
    "skipForNow": "지금은 건너뛰기",
    "skipConsequence": "답변한 프로필이 먼저 표시됩니다.",
    "confirm": "계속",
    "progressLabel": "{total}개 중 {current}번째",
    "fewSentences": "몇 문장",
    "ancestryNote": "이것은 순위에만 영향을 주는 선호 설정입니다 — 누구도 숨겨지지 않습니다."
  }
} as Messages;
